var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChooseOptionImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48032 2.77321L11.2268 10.5197C13.0304 8.35886 12.9178 5.13962 10.8891 3.11091C8.86038 1.08221 5.64114 0.969642 3.48032 2.77321ZM10.5197 11.2268L2.77321 3.48032C0.969642 5.64114 1.08221 8.86038 3.11091 10.8891C5.13962 12.9178 8.35886 13.0304 10.5197 11.2268ZM2.40381 2.40381C4.94221 -0.134602 9.05779 -0.134602 11.5962 2.40381C14.1346 4.94221 14.1346 9.05779 11.5962 11.5962C9.05779 14.1346 4.94221 14.1346 2.40381 11.5962C-0.134602 9.05779 -0.134602 4.94221 2.40381 2.40381Z",
    fill: "#B1B1B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseOptionImg);
export default __webpack_public_path__ + "static/media/choose-option-img.50239a635a7132410e07d4c34004139f.svg";
export { ForwardRef as ReactComponent };